import { createReducer, on } from '@ngrx/store';
import { FattureActions } from './fatture.actions';
import {Fattura, FattureQueryParams, LottoPassivoSummaryDto} from '../../core/models/fatture.model';

export interface FattureState {
    items: Fattura[];
    loading: boolean;
    error: string | null;

    sdiItems: LottoPassivoSummaryDto[];
    sdiLoading: boolean;
    sdiError: string | null;
    sdiImporting: boolean;

    totalElements: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    lastQuery: FattureQueryParams | undefined;

    selected: Fattura | null;

    opLoading: boolean;
    opError: string | null;
}

export const initialState: FattureState = {
    items: [],
    loading: false,
    error: null,

    totalElements: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 20,
    lastQuery: undefined,

    selected: null,

    opLoading: false,
    opError: null,

    sdiItems: [],
    sdiLoading: false,
    sdiError: null,
    sdiImporting: false,
};

export const fattureReducer = createReducer(
    initialState,

    on(FattureActions.loadList, (s, { params }) => ({ ...s, loading: true, error: null, lastQuery: params })),
    on(FattureActions.loadListSuccess, (s, { items, totalElements, totalPages, pageIndex }) => ({
        ...s,
        loading: false,
        items,
        totalElements,
        totalPages,
        pageIndex,
    })),
    on(FattureActions.loadListFailure, (s, { error }) => ({ ...s, loading: false, error })),

    on(FattureActions.loadDetails, (s) => ({ ...s, opLoading: true, opError: null, selected: null })),
    on(FattureActions.loadDetailsSuccess, (s, { item }) => ({ ...s, opLoading: false, selected: item })),
    on(FattureActions.loadDetailsFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(FattureActions.loadLottiSdiToImport, s => ({
    ...s,
    sdiLoading: true,
    sdiError: null,
  })),

  on(FattureActions.loadLottiSdiToImportSuccess, (s, { items }) => ({
    ...s,
    sdiLoading: false,
    sdiItems: items,
  })),

  on(FattureActions.loadLottiSdiToImportFailure, (s, { error }) => ({
    ...s,
    sdiLoading: false,
    sdiError: error,
  })),

  on(FattureActions.importLottiSdi, s => ({
    ...s,
    sdiImporting: true,
    sdiError: null,
  })),

  on(FattureActions.importLottiSdiSuccess, s => ({
    ...s,
    sdiImporting: false,
  })),

  on(FattureActions.importLottiSdiFailure, (s, { error }) => ({
    ...s,
    sdiImporting: false,
    sdiError: error,
  })),
  );
